<template>
  <div class="carousel-slide">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'slide',
  props: {
    tagName: {
      type: String,
      required: true,
    },
  },
};
</script>
